import { Paper } from 'shared/ui/paper'
import { Skeleton } from 'shared/ui/skeleton'

import s from './styles.module.scss'

const POLICYHOLDER_FIELD_SKELETON_COUNT = 8

export const PolicyholderSkeleton = () => (
  <Paper
    className={s.card}
    padding={[20, 16]}
  >
    <div className={s.header}>
      <Skeleton className={s.title} />
      <Skeleton className={s.subtitle} />
    </div>

    <div className={s.actions}>
      <Skeleton
        className={s.action}
        borderRadius={12}
      />
      <Skeleton
        className={s.action}
        borderRadius={12}
      />
    </div>

    <div className={s.fields}>
      {Array.from({ length: POLICYHOLDER_FIELD_SKELETON_COUNT }).map(
        (_, index) => (
          <Skeleton
            key={index}
            className={s.field}
            borderRadius={12}
          />
        ),
      )}
    </div>
  </Paper>
)
